export default "__VITE_ASSET__DmEBo8V6__"